import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-action-button-or-link',
  templateUrl: './action-button-or-link.component.html',
  styleUrls: ['./action-button-or-link.component.sass'],
})
export class ActionButtonOrLinkComponent {
  @Input() tooltipLabel = '';
  @Input() classNames: string[] = [];
  @Input() iconName = '';
  @Input() type: 'button' | 'link' | 'download' = 'button';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() link: any[] | string | null | undefined = [];
  @Input() queryParams = {};
  @Input() styleIcon = {};
  @Input() url?: string;
  @Input() disabled = false;
  @Input() loading$ = false;
  @Output() clickHandler = new EventEmitter<MouseEvent>();

  click(event: MouseEvent) {
    if (!this.disabled) {
      this.clickHandler.emit(event);
    }
  }
}
